import { EventTypes } from '../../types';
import { createMixpanelEvent } from './base';

const { menu, collection } = EventTypes;

export const MixpanelEvents = {
    [menu.clicked]: createMixpanelEvent('Collect menu clicked'),
    [menu.createCollection.clicked]: createMixpanelEvent('Collect menu create collection clicked'),

    [collection.create.success]: createMixpanelEvent('Collection created'),
    [collection.item.create.success]: createMixpanelEvent('Collection item added'),
    [collection.item.delete.success]: createMixpanelEvent('Collection item removed')
};
